import React from 'react';
import styled from 'styled-components';
import { string, number, bool, object } from 'prop-types';

import * as icons from './icons/';

export const SvgIcon = ({
  type,
  size,
  revert,
  className,
  style,
  display,
  cursor,
  color,
  hoverColor,
  isWithoutHover,
  ...props
}) => {
  const Icon = icons[type];

  const hover = isWithoutHover ?
    null :
    `&:hover {
      path {
        fill: ${hoverColor || color};
      }
    }`;

  if (!Icon) {
    return null;
  }

  const Svg = styled(Icon)`
    cursor: ${cursor};
    display: ${display};
    transform: ${revert && 'scale(1, -1)'};

    ${hover}
  `;

  return (
    <Svg
      {...props}
      color={color}
      style={style}
      className={className}
    />
  );
};

SvgIcon.propTypes = {
  type: string.isRequired,
  size: number,
  revert: bool,
  style: object,
  color: string,
  cursor: string,
  display: string,
  hoverColor: string,
  className: string,
  isWithoutHover: bool,
};

SvgIcon.defaultProps = {
  size: 14,
  style: {},
  revert: false,
  className: '',
  cursor: 'pointer',
  display: 'inline',
  color: 'currentColor',
  hoverColor: 'inherit',
  isWithoutHover: false,
};

export default SvgIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/index.js